import React from 'react';
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import './FourOhFour.sass'


const FourOhFour = () => {
  return (
    <section className="four-oh-four">
      <Helmet>
        <title>Page Not Found | Gulf TREE</title>
      </Helmet>
      <div>
        <h3>Sorry, the page you're looking for doesn't exist.</h3>
        <Link to="/" className="btn-transparent">Take me home</Link>
      </div>
    </section>
  )
}

export default FourOhFour
